import actions from './actions';

const initState = {
	dataHighlightCorrectSummary: [],
	highlightCorrectSummaryDetail: null,
	totalItems: 0,
	loading: false,
};

export default function highlightCorrectSummaryReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_HIGHLIGHT_CORRECT_SUMMARY:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_HIGHLIGHT_CORRECT_SUMMARY_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataHighlightCorrectSummary: res, totalItems, loading: false };

		case actions.GET_HIGHLIGHT_CORRECT_SUMMARY_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_HIGHLIGHT_CORRECT_SUMMARY_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, highlightCorrectSummaryDetail: res, loading: false };
		}

		case actions.LISTENING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
